// extracted by mini-css-extract-plugin
export default {"general":"_HOcyB","collapse":"x4nptw","stacked":"D0x9d0","columns":"JUtQCP","tabs":"fNY6IC"};